<div class="text-center">
    <h1 class="heading">Confirm your investment</h1>
    <div class="subheading">
        We've identified the best suited loans based on your default <b>finzyPro+</b> preferences. Your
        average return is
        <span>{{expectedRoi | number : '1.2-2'}}%</span>
        <app-rate-of-return-tooltip placement="bottom"></app-rate-of-return-tooltip>
    </div>
    <div class="row">
        <div class="col-md-4 col-md-offset-4 col-xs-12 text-center">
            <app-doughnut [dataSet]="chartData" [centerText]="'ROI: ' + expectedRoi + '%'"></app-doughnut>
        </div>
    </div>
</div>